<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="800">
    <v-form ref="form" class="py-10 px-11 white">
      <v-row>
        <v-col cols="11">
          <p class="form__title primary--text mb-5">
            {{ title }}
          </p>
        </v-col>
        <v-col cols="1" class="text-end">
          <BaseButton text icon @click="$emit('close')" class="justify-end">
            <v-icon size="17" color="gray" class="justify-end">
              fa-times
            </v-icon>
          </BaseButton>
        </v-col>
        <v-col cols="12" class="pb-5" v-if="isEdit">
          <v-switch
            v-model="form.ativo"
            class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
            inset
            dense
            hide-details
            color="secondary"
          />
          <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
            {{ statusSwitch }}
          </p>
        </v-col>
        <v-col cols="12">
          <BaseFormInput
            id-element="descriptionReason"
            placeholder="Inserir"
            v-model="form.descricao"
            required
            :rules="[requiredInput]"
            label-text="Descrição do Motivo"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <BaseFormSelect
            id-element="modalityReason"
            placeholder="Seleção"
            v-model="form.modalidades"
            :items="modalities"
            required
            :rules="[requiredInput]"
            label-text="Modalidade"
            item-text="nome"
            item-value="id"
            :return-object="true"
            multiple
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="3">
          <BaseButton
            v-html="buttonName"
            class="secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
import { requiredInput } from "@/utils/rules.js";
export default {
  data: () => ({
    requiredInput
  }),
  computed: {
    statusSwitch() {
      const value = this.form.ativo ? "Ativo" : "Inativo";
      return `Status: ${value}`;
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) this.$emit("submit", this.form);
    }
  },
  props: {
    isEdit: {
      type: Boolean
    },
    buttonName: {
      type: String
    },
    form: {
      type: Object
    },
    title: {
      type: String
    },
    modalities: {
      type: Array
    }
  }
};
</script>
